export const ReservationTypes = {
  BOOKED: "booked",
  RESERVED: "reserved",
  MAINTENANCE: "maintenance",
};
